export function getErrorMessage(error: unknown): string {
  // Prefer backend-provided array of errors: error.response.data.errors
  const response = (error as any)?.response;
  const data = response?.data;
  const errors = data?.errors;

  if (Array.isArray(errors) && errors.length > 0) {
    const messages = errors
      .map((item) => extractMessageFromErrorItem(item))
      .filter((msg): msg is string =>
        Boolean(msg && String(msg).trim().length > 0)
      );

    if (messages.length > 0) {
      return messages.join(" ");
    }
  }

  // Fallbacks: message in data/message, response.message, or error.message
  const candidates: unknown[] = [
    data?.message,
    response?.message,
    (error as any)?.message
  ];

  for (const candidate of candidates) {
    const text = coerceToString(candidate);
    if (text) return text;
  }

  // Final fallback
  return "Oops! Something went wrong, Please try again later.";
}

function extractMessageFromErrorItem(item: unknown): string | undefined {
  if (item == null) return undefined;
  if (typeof item === "string") return item;
  if (typeof item === "number" || typeof item === "boolean")
    return String(item);

  // Common shapes: { message: string }, { error: string }, { detail: string }, arrays, etc.
  const obj = item as Record<string, unknown>;
  const fromKnownKeys = coerceToString(
    obj.message ?? obj.error ?? obj.detail ?? obj.description ?? obj.title
  );
  if (fromKnownKeys) return fromKnownKeys;

  // If the item itself stringifies to something useful
  return coerceToString(item);
}

function coerceToString(value: unknown): string | undefined {
  if (value == null) return undefined;
  if (typeof value === "string") return value.trim() || undefined;
  try {
    const text = String(value);
    return text.trim() ? text : undefined;
  } catch {
    return undefined;
  }
}

export default getErrorMessage;
